import { Tooltip } from "antd";
import { healthChallenges } from "../../assets/images";
import { STATUS_DEFINITIONS } from "../../constants/overview";
import { RoundedSelect } from "../tailwind/atoms";

const StatusDataTable = ({ title, rows = [], loading = false, servicesMap = {}, currentService, handleServiceChange = () => {} }) => {
  const columns = ["Status", "#Claims", "Claimed Amount", "Settled Amount"];
  const skeletonRows = 4;

  const formatCurrency = (num) => {
    if (!num || isNaN(num)) return "-";
    return "₹" + num.toLocaleString("en-IN", { maximumFractionDigits: 0 });
  };

  // Calculate totals
  const totals = rows.reduce(
    (acc, row) => {
      acc.claims += row.total_count || 0;
      acc.claimed += row.claim_amount || 0;
      acc.incurred += row.incurred_amount || 0;
      return acc;
    },
    { claims: 0, claimed: 0, incurred: 0 }
  );

  return (
    <div className="bg-white p-6 mb-6 border border-gray-200 rounded-lg shadow-sm">
      {/* Title + Icon */}
      <div className="justify-between flex items-center mb-4">
        <div className="flex items-center gap-2 mb-4">
          <img src={healthChallenges} className="h-6 w-6 mb-2" alt="" />
          <h2 className="text-lg font-fig-semibold text-gray-800">{title}</h2>
        </div>
        <RoundedSelect
          listClasses="w-34"
          selectOptions={Object.values(servicesMap)}
          selectValues={Object.keys(servicesMap).map((_, i) => i)}
          curvalue={servicesMap[currentService] || 'Overall'}
          selectHandler={(index) =>
            handleServiceChange('status_split', Object.keys(servicesMap)[index])
          }
        />
      </div>

      <div className="overflow-x-auto">
        <table className="w-full table-auto text-left border-separate border-spacing-y-1">
          <thead>
            <tr className="bg-gray-50">
              {columns.map((col, idx) => (
                <th
                  key={idx}
                  className="py-3 px-4 text-sm font-fig-normal text-gray-700 border-b border-gray-200"
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {loading
              ? Array.from({ length: skeletonRows }).map((_, idx) => (
                  <tr key={idx} className="bg-gray-50 animate-pulse">
                    {columns.map((_, cIdx) => (
                      <td key={cIdx} className="py-3 px-4 text-sm">
                        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                      </td>
                    ))}
                  </tr>
                ))
              : rows.map((row, idx) => (
                  <tr
                    key={idx}
                    className={`transition-all duration-200 ${
                      idx % 2 === 0 ? "bg-white" : "bg-gray-50"
                    } hover:bg-blue-50`}
                  >
                    <td className="py-3 px-4 text-sm font-fig-normal text-gray-800">
                      <Tooltip title={STATUS_DEFINITIONS[row.bucket_status] || ""}>
                        {row.bucket_status}
                      </Tooltip>
                    </td>
                    <td className="py-3 px-4 text-sm text-gray-700">
                      {(row.total_count).toLocaleString("en-IN", { maximumFractionDigits: 0 }) }
                    </td>
                    <td className={`py-3 px-4 text-sm font-fig-normal text-gray-800`}>
                      {formatCurrency(row.claim_amount)}
                    </td>
                    <td className={`py-3 px-4 text-sm font-fig-normal text-gray-800`}>
                      {formatCurrency(row.incurred_amount)}
                    </td>
                  </tr>
                ))}

            {/* Total Row */}
            {!loading && rows.length > 0 && (
              <tr className="bg-blue-50 font-fig-semibold text-gray-900 border-t border-gray-200">
                <td className="py-3 px-4 text-sm">Total</td>
                <td className="py-3 px-4 text-sm">{(totals.claims).toLocaleString("en-IN", { maximumFractionDigits: 0 })}</td>
                <td className="py-3 px-4 text-sm">
                  {formatCurrency(totals.claimed)}
                </td>
                <td className="py-3 px-4 text-sm">
                  {formatCurrency(totals.incurred)}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StatusDataTable;
